module.exports = __webpack_public_path__ + "static/img/php.c3cb893.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/php.png
// module id = cu6/
// module chunks = 1